import { format } from "date-fns";
// import Select from "react-select";
import React, { useCallback, useEffect, useState } from "react";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { useAuthUser } from "../../features/auth/authHooks";
import Select from "react-select";
import {
  getAccountDetailsFromDbAsync,
  selectOwnerDetailsLoadingStatus,
  selectOwnerInfo,
  changeStateOwnerDateOfBirth,
  changeStateOwnerData,
  updateOwnerAsync,
} from "./userSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LOADING_STATUS } from "../../common/constants";
import {
  getCountriesAsync,
  selectCountryItems,
  selectCountryItemsLoadingStatus,
} from "../../features/countries/countriesSlice";
import {
  clearInputErrors,
  selectInputErrors,
} from "../../features/errors/errorsSlice";
import InputErrorsDisplay from "../../features/errors/InputErrorsDisplay";
import { addStatusToast } from "../../components/StatusToast";
import { InitialPaginationParameters } from "../../types/pagination.types";
import { AccommodationQueryFilters } from "../AccommodationsPage/accommodationsSlice";
import LocalizedDatePicker from "../../components/DatePicker/LocalizedDatePicker";
import PersonalIdentityInfo from "../../components/PersonalIdentityInfo";

const UserPageType: Page = {
  ActiveTab: "support",
  DisplayName: "Tietosi",
  DisplayParentName: "Maija Meikäläinen",
  LinkUrl: "/userDetails",
  Path: "/userDetails",
  RouteName: "userDetails",
};
/*
const initialOwnerState: OwnerInfo = {
  id: null,
  firstName: null,
  lastName: null,
};
 */
const UserPage = () => {
  const inputErrors = useAppSelector(selectInputErrors);
  //const [ownerInfo, setOwnerInfo] = useState(initialOwnerState);
  const ownerInfo = useAppSelector(selectOwnerInfo);
  const countries = useAppSelector(selectCountryItems);
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useAppDispatch();
  const ownerDetailsLoadingStatus = useAppSelector(
    selectOwnerDetailsLoadingStatus,
  );
  const countryItemsLoadingStatus = useAppSelector(
    selectCountryItemsLoadingStatus,
  );
  const { ownerAccountId } = useAuthUser();

  const initFetch = useCallback(() => {
    dispatch(getAccountDetailsFromDbAsync(ownerAccountId));
    dispatch(
      getCountriesAsync({ PageNumber: 1, PageSize: 100000, searchString: "" }),
    );
  }, [dispatch, ownerAccountId]);
  useEffect(() => {
    initFetch();
  }, [initFetch, ownerAccountId]);

  const handleInputChange = (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    const ownerData = { ...ownerInfo, [name]: value };
    dispatch(
      changeStateOwnerData({
        ownerData,
      }),
    );
  };
  const handleDateOfBirthChange = (date: Date) => {
    console.log(date);
    if (date !== undefined) {
      const dateOfBirthValue = format(new Date(date), "yyyy-MM-dd");
      dispatch(
        changeStateOwnerDateOfBirth({
          dateOfBirthValue,
        }),
      );

      // setDateOfPublication(dateOfPublication.toString());
    }
  };

  const handleOwnerSave = () => {
    const errors: string[] = [];

    if (!ownerInfo.firstName) {
      errors.push("Etunimi ei voi olla tyhjä");
    }
    if (!ownerInfo.lastName) {
      errors.push("Sukunimi ei voi olla tyhjä");
    }
    // if (!ownerInfo.birthDay) {
    //   errors.push("Syntymäaikaa ei valittu");
    // }
    // if (!ownerInfo.birthPlace) {
    //   errors.push("Syntymäpaikka ei voi olla tyhjä");
    // }
    if (!ownerInfo.postStreetAddress) {
      errors.push("Katuosoite ei voi olla tyhjä");
    }
    if (!ownerInfo.postCode) {
      errors.push("Postinumero ei voi olla tyhjä");
    }
    if (!ownerInfo.postCity) {
      errors.push("Postitoimipaikka ei voi olla tyhjä");
    }
    if (!ownerInfo.countryId || ownerInfo.countryId.length !== 36) {
      errors.push("Maa pitää valita");
    }
    if (!ownerInfo.phoneNumber) {
      errors.push("Puhelinnumero ei voi olla tyhjä");
    }
    if (!ownerInfo.emailForBookings) {
      errors.push("Sähköposti (varaukset) ei voi olla tyhjä");
    }
    const errorText = errors.join("\n");
    if (errorText) {
      alert(errorText);
      return;
    }
    setSubmitted(false);
    dispatch(updateOwnerAsync(ownerInfo)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(
          addStatusToast({
            Message: `Tiedot tallennettu!`,
          }),
        );
        setSubmitted(true);
        dispatch(clearInputErrors());
      }
    });
  };

  const countryOptions = countries.map((country) => {
    return { value: country.id, label: country.name };
  });
  const handleSelectChange = (selectedOption) => {
    const ownerData = { ...ownerInfo, ["countryId"]: selectedOption.value };
    dispatch(
      changeStateOwnerData({
        ownerData,
      }),
    );
  };
  if (
    ownerDetailsLoadingStatus == LOADING_STATUS.LOADING ||
    countryItemsLoadingStatus == LOADING_STATUS.LOADING
  ) {
    return <div />;
  }
  return (
    <div className={UserPageType.RouteName}>
      <Layout CurrentPage={UserPageType}>
        <PageHeader
          Title={UserPageType.DisplayName}
          SubTitle={
            ownerInfo.originalFirstName + " " + ownerInfo.originalLastName
          }
          Back={false}
          Icon="person"
        />

        <div className="container-narrow mx-auto d-grid gap-24">
          <Row xs={1} sm={2} className="gy-16">
            <Col>
              <Form.Label
                className="required"
                htmlFor="userFirstName"
                id="firstName"
                name="firstName"
              >
                Etunimi
              </Form.Label>
              <Form.Control
                type="text"
                defaultValue={ownerInfo.firstName}
                required
                id="firstName"
                name="firstName"
                disabled
                onChange={handleInputChange}
              />
            </Col>
            <Col>
              <Form.Label className="required" htmlFor="userLastName">
                Sukunimi
              </Form.Label>
              <Form.Control
                type="text"
                defaultValue={ownerInfo.lastName}
                required
                id="lastName"
                name="lastName"
                disabled
                onChange={handleInputChange}
              />
            </Col>
          </Row>
          {/*
          <Row xs={1} sm={2} className="gy-16">
            <Col>
              <Form.Label className="required" htmlFor="userFirstName">
                Syntymäaika
              </Form.Label>
              <div className="w-100 position-relative">
                <LocalizedDatePicker
                  selected={ownerInfo.birthDay || null}
                  onChange={(date) => handleDateOfBirthChange(date)}
                  selectsStart
                  disabled
                  className="form-control"
                  dateFormat={"dd.MM.yyyy"}
                />
                <Button
                  className="px-8 px-sm-16 position-absolute end-0 top-0 pe-none "
                  variant="link"
                  id="button-addon2"
                >
                  <span className="bi bi-calendar2-event"></span>
                </Button>
              </div>
            </Col>
            <Col>
              <Form.Label className="required" htmlFor="userBornPlace">
                Syntymäpaikka
              </Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                defaultValue={ownerInfo.birthPlace}
                required
                id="birthPlace"
                name="birthPlace"
                disabled
                onChange={handleInputChange}
              />
            </Col>
          </Row>
          */}
          <Row xs={1} sm={2} className="gy-16">
            <Col></Col>
            <Col>
              <Form.Label htmlFor="companyId">Y-tunnus</Form.Label>
              <Form.Control
                type="text"
                defaultValue={ownerInfo.businessIdentityCode}
                id="businessIdentityCode"
                name="businessIdentityCode"
                disabled
                onChange={handleInputChange}
              />
            </Col>
          </Row>
          <hr />
          <Row xs={1} sm={2} className="gy-16">
            <Col>
              <Form.Label className="required" htmlFor="userStreet">
                Katuosoite
              </Form.Label>
              <Form.Control
                type="text"
                defaultValue={ownerInfo.postStreetAddress}
                required
                id="postStreetAddress"
                name="postStreetAddress"
                disabled
                onChange={handleInputChange}
              />
            </Col>
            <Col>
              <Form.Label className="required" htmlFor="userPostNum">
                Postinumero
              </Form.Label>
              <Form.Control
                type="text"
                defaultValue={ownerInfo.postCode}
                required
                id="postCode"
                name="postCode"
                disabled
                onChange={handleInputChange}
              />
            </Col>
          </Row>
          <Row xs={1} sm={2} className="gy-16">
            <Col>
              <Form.Label className="required" htmlFor="userCity">
                Postitoimipaikka
              </Form.Label>
              <Form.Control
                type="text"
                defaultValue={ownerInfo.postCity}
                required
                id="postCity"
                name="postCity"
                disabled
                onChange={handleInputChange}
              />
            </Col>
            <Col>
              <Form.Label className="required" htmlFor="userCountry">
                Maa
              </Form.Label>
              <Select
                inputId="countryId"
                name="countryId"
                placeholder="Valitse maa"
                isClearable
                isSearchable
                isDisabled={true}
                options={countryOptions}
                onChange={(option) => handleSelectChange(option)}
                defaultValue={countryOptions.filter(
                  (option) => option.value === ownerInfo.countryId,
                )}
              />
            </Col>
          </Row>
          <hr />
          <Row xs={1} sm={2} className="gy-16">
            <Col>
              <Form.Label className="required" htmlFor="userPhoneArea">
                Puhelin
              </Form.Label>
              <div className="d-flex gap-8">
                <Form.Control
                  type="text"
                  defaultValue={ownerInfo.phoneNumber}
                  required
                  id="phoneNumber"
                  name="phoneNumber"
                  disabled
                  onChange={handleInputChange}
                />
              </div>
            </Col>
          </Row>
          <Row xs={1} sm={2} className="gy-16">
            <Col>
              <Form.Label htmlFor="userEmail">
                Sähköposti (Ota yhteys lomarenkaan tukeen muutosta varten)
              </Form.Label>
              <Form.Control
                type="email"
                defaultValue={ownerInfo.email}
                id="email"
                name="email"
                disabled
                onChange={handleInputChange}
              />
            </Col>
            {ownerInfo.emailForBookings != null && (
              <Col>
                <Form.Label htmlFor="userEmailBookings">
                  Sähköposti (varaukset)
                </Form.Label>
                <Form.Control
                  type="email"
                  defaultValue={ownerInfo.emailForBookings}
                  id="emailForBookings"
                  name="emailForBookings"
                  disabled
                  onChange={handleInputChange}
                />
              </Col>
            )}
          </Row>
          <hr />
          {/*}
          <div className="d-flex justify-content-between">
            <a href="/" className="btn btn-link px-0">
              Peruuta
            </a>
            <Button variant="primary" onClick={handleOwnerSave}>
              Tallenna
            </Button>
          </div>
          {*/}
          {submitted && <Alert variant="success">Tiedot tallennettu!</Alert>}
          <InputErrorsDisplay inputErrors={inputErrors} />
          <PersonalIdentityInfo />
        </div>
      </Layout>
    </div>
  );
};

export default UserPage;
